<div class="informative">
  <div class="p-row">
    <po-widget class="po-lg-3 po-md-3 po-sm-6 po-mt-2 widget-fixed-height"
      p-title="Total de vendas" [p-tooltip]="itemTotalTooltip">
      <div class="icon-loading" *ngIf="loading">
        <app-loading-icon></app-loading-icon>
      </div>
      <div class="po-font-subtitle po-text-center" *ngIf="!loading">
        <span class="po-font-text-small" *ngIf="itemTotalValidation != null">R$</span>
        <span *ngIf="itemTotalValidation != null">{{itemTotalSplit}}</span>
        <span *ngIf="itemTotalValidation == null">
          <span class="po-icon po-icon-exclamation"></span>
        </span>
      </div>
      <div class="po-font-text-small po-text-center quantity-info">
        <span *ngIf="!loading && itemQuantityValidation != null">{{itemQuantitySplit}} peças vendidas</span>
        <span *ngIf="loading || itemQuantityValidation == null">&nbsp;</span>
      </div>
      <div class="po-font-subtitle po-text-center" *ngIf="!loading && !isNumber(itemTotalLastYear)">
        <span class="po-font-text-small">Ano anterior</span>
        <span class="po-font-text-large-bold"> 
          <span *ngIf="itemTotalLastYear < 0" class="po-icon po-icon-arrow-down" style="color: 'red'; margin-left: 10px;"></span><span *ngIf="itemTotalLastYear > 0" class="po-icon po-icon-arrow-up" style="color: 'green'; margin-left: 10px;"></span> {{itemTotalLastYear}}%
        </span>
        <span *ngIf="itemTmValidation == null">
          <span class="po-icon po-icon-exclamation"></span>
        </span>
      </div>
      <div class="po-font-subtitle po-text-center detail-informative po-clickable" *ngIf="!loading && !isNumber(itemTotalLastYear)" (click)="goToDetail()">
        <span class="po-font-text-small">+ Detalhes</span>
      </div>
    </po-widget>
    <po-widget class="po-lg-3 po-md-3 po-sm-6 po-mt-2 widget-fixed-height" p-title="Ticket médio"
      [p-tooltip]="itemTmTooltip">
      <div class="icon-loading" *ngIf="loading">
        <app-loading-icon></app-loading-icon>
      </div>
      <div class="po-font-subtitle po-text-center" *ngIf="!loading ">
        <span class="po-font-text-small" *ngIf="itemTmValidation != null">R$</span>
        <span *ngIf="itemTmValidation != null">{{itemTmSplit}}</span>
        <span *ngIf="itemTmValidation == null">
          <span class="po-icon po-icon-exclamation"></span>
        </span>
      </div>
      <div class="po-font-text-small po-text-center quantity-info">
        <span>&nbsp;</span>
      </div>
      <div class="po-font-subtitle po-text-center" *ngIf="!loading && !isNumber(itemTmLastYear)">
        <span class="po-font-text-small">Ano anterior</span>
        <span class="po-font-text-large-bold"> 
          <span *ngIf="itemTmLastYear < 0" class="po-icon po-icon-arrow-down" style="color: 'red'; margin-left: 10px;"></span><span *ngIf="itemTmLastYear > 0" class="po-icon po-icon-arrow-up" style="color: 'green'; margin-left: 10px;"></span> {{itemTmLastYear}}%
        </span>
        <span *ngIf="itemTmValidation == null">
          <span class="po-icon po-icon-exclamation"></span>
        </span>
      </div>
      <div class="po-font-subtitle po-text-center detail-informative po-clickable" *ngIf="!loading && !isNumber(itemTotalLastYear)" (click)="goToDetail()">
        <span class="po-font-text-small">+ Detalhes</span>
      </div>
    </po-widget>
    <po-widget class="po-lg-3 po-md-3 po-sm-6 po-mt-2 widget-fixed-height" p-title="PMPV"
      [p-tooltip]="itemPmpvTooltip">
      <div class="icon-loading" *ngIf="loading">
        <app-loading-icon></app-loading-icon>
      </div>
      <div class="po-font-subtitle po-text-center" *ngIf="!loading">
        <span class="po-font-text-small" *ngIf="itemPmpvValidation != null">R$</span>
        <span *ngIf="itemPmpvValidation != null">{{itemPmpv}}</span>
        <span *ngIf="itemPmpvValidation == null">
          <span class="po-icon po-icon-exclamation"></span>
        </span>
      </div>
      <div class="po-font-text-small po-text-center quantity-info">
        <span>&nbsp;</span>
      </div>
      <div class="po-font-subtitle po-text-center" *ngIf="!loading && !isNumber(itemPmpvLastYear)">
        <span class="po-font-text-small">Ano anterior</span>
        <span class="po-font-text-large-bold"> 
          <span *ngIf="itemPmpvLastYear < 0" class="po-icon po-icon-arrow-down" style="color: 'red'; margin-left: 10px;"></span><span *ngIf="itemPmpvLastYear > 0" class="po-icon po-icon-arrow-up" style="color: 'green'; margin-left: 10px;"></span> {{itemPmpvLastYear}}%
        </span>
        <span *ngIf="itemTmValidation == null">
          <span class="po-icon po-icon-exclamation"></span>
        </span>
      </div>
      <div class="po-font-subtitle po-text-center detail-informative po-clickable" *ngIf="!loading && !isNumber(itemTotalLastYear)" (click)="goToDetail()">
        <span class="po-font-text-small">+ Detalhes</span>
      </div>
    </po-widget>
    <po-widget class="po-lg-3 po-md-3 po-sm-6 po-mt-2 widget-fixed-height" p-title="PA"
      [p-tooltip]="itemPaTooltip">
      <div class="icon-loading" *ngIf="loading">
        <app-loading-icon></app-loading-icon>
      </div>
      <div class="po-font-subtitle po-text-center" *ngIf="!loading">
        <span *ngIf="itemPaValidation != null">{{itemPa}}</span>
        <span *ngIf="itemPaValidation == null">
          <span class="po-icon po-icon-exclamation"></span>
        </span>
      </div>
      <div class="po-font-text-small po-text-center quantity-info">
        <span>&nbsp;</span>
      </div>
      <div class="po-font-subtitle po-text-center" *ngIf="!loading && !isNumber(itemPaLastYear)">
        <span class="po-font-text-small">Ano anterior</span>
        <span class="po-font-text-large-bold"> 
          <span *ngIf="itemPaLastYear < 0" class="po-icon po-icon-arrow-down" style="color: 'red'; margin-left: 10px;"></span><span *ngIf="itemPaLastYear > 0" class="po-icon po-icon-arrow-up" style="color: 'green'; margin-left: 10px;"></span> {{itemPaLastYear}}%
        </span>
        <span *ngIf="itemTmValidation == null">
          <span class="po-icon po-icon-exclamation"></span>
        </span>
      </div>
      <div class="po-font-subtitle po-text-center detail-informative po-clickable" *ngIf="!loading && !isNumber(itemTotalLastYear)" (click)="goToDetail()">
        <span class="po-font-text-small">+ Detalhes</span>
      </div>
    </po-widget>
  </div>
</div>